import React from 'react';
import UserCard from '../ProfileCard';
import { Elements } from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm'
import CardInfo from './CreditInfo'
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'
export default class Component extends React.Component {

  componentDidMount = () => {
  }

  onSubmit = (e) => {
    e.preventDefault();
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const metaInfo = (
      <Helmet>
        <title>クレジットカード情報 | {SG.META_TITLE}</title>
        <meta name='description' content='クレジットカード情報です。' />
      </Helmet>
    )
    return (
      <div className='container'>
        {metaInfo}
        <UserCard user={currentUser} cardEditHide={true} />
        {(() => {
          if (currentUser.has_card) {
            return (
              <CardInfo />
            )
          } else {
            return (
              <Elements>
                <CheckoutForm />
              </Elements>
            )
          }
        })()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/Credit/Credit.jsx